module.exports = __webpack_public_path__ + "static/other/career_fair.91546c8d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/career_fair.json
// module id = 2340
// module chunks = 0